var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./content.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler?{\"id\":\"data-v-57875868\"}!../../vue-loader/lib/selector?type=template&index=0!./content.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/ci-components/components/content.vue
// module id = 242
// module chunks = 4